import { render } from "./Services.vue?vue&type=template&id=7b744939&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=7b744939&scoped=true&lang=scss"
import "./Services.vue?vue&type=style&index=1&id=7b744939&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b744939"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSpinnerGears,QToolbarTitle,QBtn,QPopupProxy,QBanner,QTooltip,QTable,QTd,QSpinner});qInstall(script, 'directives', {Ripple});
